import React from 'react';
import Button, { ButtonSize, ButtonVariant } from './ui/Button';
import { useScheduling } from '../context/SchedulingContext';

interface BookConsultationButtonProps {
  label?: string;
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
  className?: string;
  onClick?: () => void;
}

const BookConsultationButton: React.FC<BookConsultationButtonProps> = ({
  label = 'Book a consultation',
  variant = 'primary',
  size = 'md',
  fullWidth,
  className,
  onClick,
}) => {
  const { open } = useScheduling();

  return (
    <Button
      variant={variant}
      size={size}
      fullWidth={fullWidth}
      className={className}
      aria-haspopup="dialog"
      onClick={() => {
        onClick?.();
        open();
      }}
    >
      {label}
    </Button>
  );
};

export default BookConsultationButton;
